export const DEFAULT_ERROR_STATE = {
  title: 'Não foi possível concluir a sua solicitação',
  message: 'Entre em contato com a nossa Central de Atendimento',
}
